import React from "react";
import Marquee from "@/components/Marquee";

export default function U2Partner() {
  return (
    <div className="bg-black text-white min-h-screen overflow-hidden">
      {/* 
        SEO TIP: 确保你的页面配置了正确的 <title> 和 <meta description>。
        Title: U2 Casino Agent | Best Online Casino Platform & Betting Dashboard
      */}

      {/* HERO SECTION */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT CONTENT */}
          <div>
            {/* 增加核心关键字前置 */}
            <div className="inline-block px-4 py-2 rounded-full border border-orange-500/30 bg-orange-500/10 text-orange-400 text-sm font-bold tracking-widest mb-6 uppercase">
              #1 Trusted U2 Casino Agent Platform
            </div>

            <h1 className="text-5xl lg:text-7xl font-black leading-tight mb-6">
              U2
              <br />
              <span className="text-orange-500 drop-shadow-[0_0_25px_rgba(249,115,22,0.8)] uppercase">
                Best Online Casino
              </span>
            </h1>

            {/* 这里的文案融入了更多行业热词：Slots, Betting, Commission */}
            <p className="text-zinc-400 text-lg leading-8 max-w-2xl mb-10">
              Join the elite <strong>U2 Casino Agent</strong> network. Our platform offers the most seamless 
              <strong> online betting experience</strong> with high-speed <strong>slot gaming</strong>, 
              live dealer stability, and a high-commission partner dashboard designed for growth.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://regismyr.wlrdr.xyz/RE/NjljZGRlZWVlNjY0NjRmNjRiN2U0OWQ4"
                target="_blank"
                rel="noreferrer"
                className="px-8 py-4 rounded-full bg-orange-500 hover:bg-orange-400 transition-all duration-300 text-black font-bold shadow-[0_0_30px_rgba(249,115,22,0.5)]"
              >
                Register U2 Account
              </a>

              <a
                href="/contact"
                className="px-8 py-4 rounded-full border border-orange-500 text-orange-400 hover:bg-orange-500 hover:text-black transition-all duration-300 font-semibold"
              >
                Agent Inquiry
              </a>
            </div>
          </div>

          {/* RIGHT SIDE CARDS - 保持结构，优化文字 */}
          <div className="grid grid-cols-2 gap-5">
            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">LIVE</h2>
              <p className="text-xl font-bold mb-2">BET MONITOR</p>
              <p className="text-zinc-500 text-sm leading-6">
                Real-time tracking of all betting activities and platform turnover.
              </p>
            </div>
            <div className="rounded-3xl border border-orange-500/20 bg-zinc-900/70 p-8 hover:scale-105 transition-all duration-300">
              <h2 className="text-4xl font-black text-orange-500 mb-2">SECURE</h2>
              <p className="text-xl font-bold mb-2">E-WALLET</p>
              <p className="text-zinc-500 text-sm leading-6">
                Fast deposit and withdrawal integration with multi-layer encryption.
              </p>
            </div>
            {/* ... 其他卡片建议保持简洁但包含核心功能词 ... */}
          </div>
        </div>
      </section>

      {/* SEO DEEP CONTENT - 这里是冲排名的关键 */}
      <section className="py-20 border-t border-orange-500/10 bg-zinc-950">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-5xl font-black mb-6">
              Why U2 is the Leading 
              <span className="text-orange-500"> Online Casino Platform </span>
              in 2026
            </h2>
            <p className="text-zinc-400 text-lg max-w-4xl mx-auto leading-relaxed">
              As a premier <strong>U2 Casino Agent</strong>, we provide a robust ecosystem for 
              <strong> online gambling</strong> enthusiasts. Whether you are looking for 
              <strong> live casino games</strong>, sportsbooks, or the latest <strong>online slots</strong>, 
              our digital platform ensures 99.9% uptime and a mobile-first responsive design.
            </p>
          </div>

          {/* 增加一个 FAQ 部分，这非常利于 SEO */}
          <div className="grid md:grid-cols-2 gap-12 mt-10">
            <div>
              <h3 className="text-2xl font-bold text-orange-500 mb-4">Top-Tier Casino Games</h3>
              <p className="text-zinc-400 mb-6">
                Our platform integrates with world-class game providers to deliver 
                fair play and high RTP (Return to Player) experiences for all users.
              </p>
              <h3 className="text-2xl font-bold text-orange-500 mb-4">Advanced Agent System</h3>
              <p className="text-zinc-400">
                The U2 Dashboard allows partners to monitor growth, track performance, 
                and optimize marketing strategies with professional digital tools.
              </p>
            </div>
            
            <div className="bg-zinc-900/50 p-8 rounded-3xl border border-orange-500/10">
              <h3 className="text-xl font-bold mb-4">Frequently Asked Questions</h3>
              <ul className="space-y-4 text-sm text-zinc-400">
                <li>
                  <strong className="text-white block">How to join U2 Casino Agent?</strong>
                  Simply click the 'Get Started' button and register your agent account today.
                </li>
                <li>
                  <strong className="text-white block">Is the platform mobile friendly?</strong>
                  Yes, U2 Casino is fully optimized for iOS, Android, and desktop browsers.
                </li>
                <li>
                  <strong className="text-white block">What games are available?</strong>
                  We offer Slots, Live Baccarat, Roulette, Sports Betting, and more.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <Marquee />
    </div>
  );
}
